import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Flex, Heading, Text, Link } from "@chakra-ui/react";
import color from "../../config/color";
import { DateTime } from "luxon";

const ErrorPage = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();

  const email = "service@19gale.ai";

  const newLineChar = "%0D%0A"; // for link, \n won't work
  const subject = "良美興後臺管理系統bug回報";
  const message = `錯誤資訊 ${newLineChar}${newLineChar}
版本：${process.env.REACT_APP_VERSION} ${newLineChar}
時間：${DateTime.local().toLocaleString()} ${newLineChar}
console： ${error.message}${newLineChar}${error.stack} ${newLineChar}${newLineChar}
描述錯誤：${newLineChar}${newLineChar}
造成錯誤的步驟：${newLineChar}
1.${newLineChar}${newLineChar}
其他：`;

  console.log(message);

  const goToHomePage = () => {
    navigate("/");
    resetErrorBoundary();
  };

  return (
    <Flex ml={4} mt={4} direction="column" gap={4}>
      <Heading>錯誤</Heading>
      <Text whiteSpace="pre">您好：程式發生了錯誤，詳細資訊如下：</Text>
      <Text color="red.500">{error.message}</Text>
      <Text color="red.500">{error.stack}</Text>
      <Text>
        請將問題回報給開發團隊，以便進行修復。email：
        <Link
          color="blue.500"
          href={`mailto:${email}?subject=${subject}&body=${message}`}
        >
          {email}
        </Link>
      </Text>
      <Button
        colorScheme="orange"
        bgColor={color.orange}
        w="fit-content"
        onClick={goToHomePage}
      >
        回到主頁
      </Button>
    </Flex>
  );
};

export default ErrorPage;
